import { classNames } from '@axo/shared/util/dom';
import bankStyles from '../BankPanel.module.css';
import { StatusTag } from '../../StatusTag';
import { Tag, Tooltip } from '@blueprintjs/core';
import { IGroupingStatuses } from '../../../models/tableConfig';
import {
  loan_quote,
  lender_filter_result,
} from '@axo/shared/data-access/types';
import {
  ApplicationDataTabType,
  useApplicationDataStore,
} from '../../../store/applicationDataStore';

const RequestStatusTooltipContent = ({
  lenderFilterResults,
  quote,
}: {
  lenderFilterResults?: lender_filter_result.LenderFilterResult[];
  quote: loan_quote.BankQuote;
}) => {
  return (
    <>
      {lenderFilterResults && lenderFilterResults.length > 0 && (
        <div>
          <span>
            <b>Lender Filter Results</b>
          </span>
          <br />
          <ul>
            {lenderFilterResults.map((lenderFilterResult) => (
              <li key={lenderFilterResult.ID}>{lenderFilterResult.Result}</li>
            ))}
          </ul>
        </div>
      )}
      <div>
        <span>
          <b>{quote.LoanRequest.Status}</b>
        </span>
        {quote.LoanRequest.LenderStatus && (
          <>
            <br />
            <span>{quote.LoanRequest.LenderStatus}</span>
          </>
        )}
      </div>
    </>
  );
};

export const LoanRequestStatus = ({
  applicationID,
  item,
  groupedStatuses,
  onClick,
  lenderFilterResult,
}: {
  applicationID: string;
  item: loan_quote.BankQuote;
  groupedStatuses: IGroupingStatuses;
  onClick: (lenderID: string, loanRequestID: string) => void;
  lenderFilterResult: lender_filter_result.LenderFilterResult[];
}) => {
  const { selectedTab } = useApplicationDataStore(applicationID);

  const loanRequestStatus = item.LoanRequest.Status;

  // Only render first cell in group
  if (
    groupedStatuses['LoanRequestID'].isInGroup &&
    !groupedStatuses['LoanRequestID'].isFirstInGroup
  ) {
    return (
      <div
        className={classNames(
          bankStyles.tagContainer,
          bankStyles.grouped,
          groupedStatuses['LoanRequestID'].isLastInGroup &&
            bankStyles.lastInGroup,
        )}
      />
    );
  }

  return (
    <div
      className={classNames(
        bankStyles.tagContainer,
        groupedStatuses['LoanRequestID'].isInGroup && bankStyles.grouped,
        groupedStatuses['LoanRequestID'].isFirstInGroup &&
          bankStyles.firstInGroup,
      )}
    >
      {!loanRequestStatus && '-'}
      {loanRequestStatus && (
        <Tooltip
          content={
            <RequestStatusTooltipContent
              lenderFilterResults={lenderFilterResult}
              quote={item}
            />
          }
          placement="bottom"
          renderTarget={({ isOpen: _, ...targetProps }) => (
            <span {...targetProps}>
              <StatusTag
                status={loanRequestStatus}
                classes={{
                  tag: classNames(
                    selectedTab.type === ApplicationDataTabType.REQUEST &&
                      item.LoanRequestID === selectedTab.requestID &&
                      bankStyles.selectedLoanRequestsTag,
                    bankStyles.loanRequestsTag,
                  ),
                }}
                onClick={() => onClick(item.LenderID, item.LoanRequestID)}
              >
                {item.LoanRequest.Status}
              </StatusTag>
            </span>
          )}
        />
      )}
      {groupedStatuses['LoanRequestID'].isInGroup &&
      !groupedStatuses?.['LoanQuoteID']?.isInGroup ? (
        <Tooltip
          content="Multiple offers from this lender. Only one offer can be accepted. Accept the desired offer first, then deny the remaining offer(s) to avoid issues."
          placement="bottom"
          renderTarget={({ isOpen: _, ...targetProps }) => (
            <Tag {...targetProps}>Multiple offers</Tag>
          )}
        />
      ) : undefined}
      {groupedStatuses['LoanRequestID'].isInGroup &&
      groupedStatuses?.['LoanQuoteID']?.isInGroup ? (
        <Tooltip
          content="Combo offer: both offers must be accepted together or not at all."
          placement="bottom"
          renderTarget={({ isOpen: _, ...targetProps }) => (
            <Tag {...targetProps}>Combo offer</Tag>
          )}
        />
      ) : undefined}
    </div>
  );
};
